import * as Comlink from "comlink";
// eslint-disable-next-line
import Worker from "worker-loader!./worker"; // inline loader
import { WorkerApi } from "./worker";

const worker = new Worker();

const wrapper = Comlink.wrap<WorkerApi>(worker);
const proxy = Comlink.proxy(worker);

export default { wrapper, proxy };
